document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.iframe-size-to-content').forEach(iframe => {
    iframe.addEventListener('load', () => {
      // eslint-disable-next-line no-param-reassign
      iframe.style.height = `${iframe.contentDocument.body.scrollHeight}px`;
    });
  });
});
